import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SOCIALS = [
  { name: "Instagram", url: "https://instagram.com/4intdeadyet" },
  { name: "YouTube", url: "https://youtube.com/@Aintdead-Yet" },
  { name: "TikTok", url: "https://tiktok.com/@aintdead_yet" },
  { name: "Discord", url: "https://discord.gg/CPyetCc9HX" },
];

// Local asset — no third-party CDN dependency
export const COVER_IMG = "/program-cover.jpg";

export const api = axios.create({ baseURL: API });
